/**
 * @package   paddle
 * @copyright Copyright (c)2021-2024 Akeeba Ltd
 * @license   GNU General Public License version 3, or later
 */

window.akeeba               = window.akeeba || {};
window.akeeba.Paddle        = window.akeeba.Paddle || {};
window.akeeba.Paddle.signup = window.akeeba.Paddle.signup || {
    "onUsernameValidate":  function ()
                           {
                               let pageOptions = Joomla.getOptions("com_paddle.product");
                               let form        = document.forms["signupForm"];

                               // Only apply the additional validation once the first on submit validation has kicked in
                               if (!form.classList.contains("was-validated"))
                               {
                                   return true;
                               }

                               let inUsername        = document.getElementById("comPaddleUsername");
                               let wasUsernameReused = pageOptions.validation["username.unique"] === false;
                               let elUsernameUnique  = document.getElementById("comPaddleErrorUsernameUnique");
                               let invalidUsername   = pageOptions.session.username ?? "";
                               let elEmptyError      = document.getElementById("comPaddleErrorUsernameEmpty");
                               let elCurrentUsername = inUsername.value;

                               if (elUsernameUnique)
                               {
                                   elUsernameUnique.classList.add("d-none");
                                   elEmptyError.classList.remove("d-none");
                                   inUsername.classList.remove("is-invalid");

                                   if (elCurrentUsername.length > 0 && wasUsernameReused)
                                   {
                                       inUsername.setCustomValidity('');
                                       inUsername.reportValidity();

                                       if (elCurrentUsername.toLowerCase() === invalidUsername.toLowerCase())
                                       {
                                           elUsernameUnique.classList.remove("d-none");
                                           elEmptyError.classList.add("d-none");

                                           inUsername.setCustomValidity(elUsernameUnique.innerText);
                                           inUsername.reportValidity();

                                           return false;
                                       }
                                   }
                               }

                               return true;
                           },
    "onEmailValidate":     function ()
                           {
                               let pageOptions = Joomla.getOptions("com_paddle.product");
                               let form        = document.forms["signupForm"];
                               let inEmail     = document.getElementById("comPaddleEmail");

                               // Only apply the additional validation once the first on submit validation has kicked in
                               if (!form.classList.contains("was-validated"))
                               {
                                   return true;
                               }

                               let wasEmailReused = pageOptions.validation["email.unique"] === false;
                               let elEmailUnique  = document.getElementById("comPaddleErrorEmailUnique");
                               let invalidEmail   = pageOptions.session.email ?? "";
                               let elEmptyError   = document.getElementById("comPaddleErrorEmailEmpty");
                               let elCurrentEmail = inEmail.value;

                               if (elEmailUnique)
                               {
                                   elEmailUnique.classList.add("d-none");
                                   elEmptyError.classList.remove("d-none");
                                   inEmail.classList.remove("is-invalid");

                                   if (elCurrentEmail.length > 0 && wasEmailReused)
                                   {
                                       inEmail.setCustomValidation('');
                                       inEmail.reportValidity();

                                       if (elCurrentEmail.toLowerCase() === invalidEmail.toLowerCase())
                                       {
                                           elEmailUnique.classList.remove("d-none");
                                           elEmptyError.classList.add("d-none");

                                           inEmail.setCustomValidation(elEmailUnique.innerText);
                                           inEmail.reportValidity();

                                           return false;
                                       }
                                   }
                               }

                               return true;
                           },
    "onEmail2Validate":    function ()
                           {
                               let pageOptions = Joomla.getOptions("com_paddle.product");
                               let form        = document.forms["signupForm"];
                               let inEmail     = document.getElementById("comPaddleEmail");
                               let inEmail2    = document.getElementById("comPaddleEmail2");

                               // Only apply the additional validation once the first on submit validation has kicked in
                               if (!form.classList.contains("was-validated"))
                               {
                                   return true;
                               }

                               let currentEmail  = inEmail.value;
                               let currentEmail2 = inEmail2.value;
                               let isSameEmail   = (currentEmail.length > 0) && (currentEmail.toLowerCase() === currentEmail2.toLowerCase());
                               let elEmailMatch  = document.getElementById("comPaddleErrorEmailMatch");
                               let elEmptyError  = document.getElementById("comPaddleErrorEmail2Empty");

                               if (elEmailMatch)
                               {
                                   elEmailMatch.classList.add("d-none");
                                   elEmptyError.classList.remove("d-none");
                                   inEmail2.classList.remove("is-invalid");

                                   if (currentEmail2.length > 0)
                                   {
                                       inEmail2.setCustomValidity("");
                                       inEmail2.reportValidity();

                                       if (!isSameEmail)
                                       {
                                           elEmailMatch.classList.remove("d-none");
                                           elEmptyError.classList.add("d-none");

                                           inEmail2.setCustomValidity(elEmailMatch.innerText);
                                           inEmail2.reportValidity();

                                           return false;
                                       }
                                   }
                               }

                               return true;
                           },
    "onPassword2Validate": function ()
                           {
                               let pageOptions = Joomla.getOptions("com_paddle.product");
                               let form        = document.forms["signupForm"];
                               let inPassword  = document.getElementById("comPaddlePassword");
                               let inPassword2 = document.getElementById("comPaddlePassword2");

                               // Only apply the additional validation once the first on submit validation has kicked in
                               if (!form.classList.contains("was-validated"))
                               {
                                   return true;
                               }

                               if ((typeof inPassword === "undefined") || (typeof inPassword2 === "undefined"))
                               {
                                   return true;
                               }

                               let currentPassword  = inPassword.value;
                               let currentPassword2 = inPassword2.value;
                               let isSamePassword   = (currentPassword.length > 0) && (currentPassword === currentPassword2);
                               let elPasswordMatch  = document.getElementById("comPaddleErrorPasswordMatch");
                               let elEmptyError     = document.getElementById("comPaddleErrorPassword2Empty");

                               if (elPasswordMatch)
                               {
                                   elPasswordMatch.classList.add("d-none");
                                   elEmptyError.classList.remove("d-none");
                                   inPassword2.classList.remove("is-invalid");

                                   if (currentPassword2.length > 0)
                                   {
                                       inPassword2.setCustomValidity("");
                                       inPassword2.reportValidity();

                                       if (!isSamePassword)
                                       {
                                           elPasswordMatch.classList.remove("d-none");
                                           elEmptyError.classList.add("d-none");

                                           inPassword2.setCustomValidity(elPasswordMatch.innerText);
                                           inPassword2.reportValidity();

                                           return false;
                                       }
                                   }
                               }

                               return true;
                           },
};

window.addEventListener("DOMContentLoaded", function ()
{
    let pageOptions = Joomla.getOptions("com_paddle.product");
    let form        = document.forms["signupForm"];

    form.addEventListener("submit", function (event)
    {
        form.classList.add("was-validated");

        // DO NOT INLINE THESE VARIABLES!
        // We need to forcibly run all of these validators. If you inline them boolean short-circuit evaluation
        // kicks in, the validators dd not run, therefore we do not see the validation results on the form.
        let validUsername  = akeeba.Paddle.signup.onUsernameValidate();
        let validEmail     = akeeba.Paddle.signup.onEmailValidate();
        let validEmail2    = akeeba.Paddle.signup.onEmail2Validate();
        let validPassword2 = akeeba.Paddle.signup.onPassword2Validate();

        if (!form.checkValidity() || !validUsername || !validEmail || !validEmail2 || !validPassword2)
        {
            event.preventDefault();
            event.stopPropagation();

            return false;
        }
    }, false);

    // Toggle reused username error
    document.getElementById("comPaddleUsername")?.addEventListener("input", akeeba.Paddle.signup.onUsernameValidate);

    // Toggle reused email error
    document.getElementById("comPaddleEmail").addEventListener("input", akeeba.Paddle.signup.onEmailValidate);

    // Toggle emails don't match error
    document.getElementById("comPaddleEmail").addEventListener("input", function (event) {
        akeeba.Paddle.signup.onEmail2Validate();
        document.getElementById("comPaddleEmail").focus();
    });
    document.getElementById("comPaddleEmail2").addEventListener("input", akeeba.Paddle.signup.onEmail2Validate);

    // Toggle passwords don't match error
    document.getElementById("comPaddlePassword")?.addEventListener("input", function (event) {
        akeeba.Paddle.signup.onPassword2Validate();
        document.getElementById("comPaddlePassword").focus();
    });
    document.getElementById("comPaddlePassword2")?.addEventListener("input", akeeba.Paddle.signup.onPassword2Validate);
});